// --------------------------------------------------------------
// Created On: 2021-10-04
// Author: Zachary Thomas
//
// Last Modified: 2022-05-26
// Modified By: Zachary Thomas
//
// Copyright 2021 - 2022 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import Card from "../../../components/Card/Card";
import Document from "./Document/Document";
import PropTypes, { InferProps } from "prop-types";

// List of viewable or downloadable documents.
export default function DocumentContainer(props: Props): Component {
  return (
    <div className="p-4">
      {props.manuals.length > 0 || props.curves.length > 0 ? (
        <Fragment>
          {props.manuals.length > 0 && (
            <div className="col-12 col-xl-10 col-xxl-8 offset-xl-1 offset-xxl-2 pb-4">
              <Card title={`${props.assetName}'s Manuals`}>
                <div className="p-4">
                  {props.manuals.map((manual) => (
                    <Document
                      key={manual.resourceId}
                      name={manual.name}
                      endpoint={manual.endpoint}
                    />
                  ))}
                </div>
              </Card>
            </div>
          )}

          {props.curves.length > 0 && (
            <div className="col-12 col-xl-10 col-xxl-8 offset-xl-1 offset-xxl-2">
              <Card title={`${props.assetName}'s Pump Curves`}>
                <div className="p-4">
                  {props.curves.map((curve) => (
                    <Document key={curve.resourceId} name={curve.name} endpoint={curve.endpoint} />
                  ))}
                </div>
              </Card>
            </div>
          )}
        </Fragment>
      ) : (
        <Card title="Documents">
          <p className="h4 text-center py-5 px-4">No documents found for {props.assetName}</p>
        </Card>
      )}
    </div>
  );
}

DocumentContainer.propTypes = {
  assetName: PropTypes.string.isRequired,
  manuals: PropTypes.array.isRequired,
  curves: PropTypes.array.isRequired,
};

type Props = InferProps<typeof DocumentContainer.propTypes>;
